module.exports = __webpack_public_path__ + "static/media/Linkedin.1d3d9413.svg";